import styles from './skeleton.module.scss';
import clsx from 'clsx';

type Props = {
  className?: string;
};
export default function Skeleton({ className }: Props) {
  return <>{<span className={clsx(styles.skeleton, styles.loading, className)}></span>}</>;
}
